import { Loader2 } from "lucide-react";
import useAuthStore from "../../store/auth.store";
import { logout as apiLogout } from "../../api/auth.api";

/**
 * Pre-launch maintenance page.
 *
 * Rendered for users whose account is on `status === "STANDBY"` — set
 * by Manivannan via /admin/auth/user/ for accounts that signed up
 * before public launch. Users land here on every protected route until
 * their status is flipped back to "ACTIVE".
 */
export default function Maintenance() {
  const user = useAuthStore((s) => s.user);
  const clearAuth = useAuthStore((s) => s.clearAuth);

  const handleSignOut = async () => {
    try {
      await apiLogout();
    } catch {}
    clearAuth?.();
    window.location.assign("/login");
  };

  return (
    <div className="min-h-[100dvh] bg-bg-main text-text-primary flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="text-button-primary font-extrabold text-4xl mb-2">
          Zen<span className="text-text-primary">cricket</span>data
        </div>
        <div className="text-text-secondary text-xs uppercase tracking-[0.2em] mb-8">
          private beta
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold mb-4">
          We're not live yet
        </h1>

        <p className="text-text-secondary leading-relaxed mb-6">
          Thanks for signing up{user?.first_name ? `, ${user.first_name}` : ""}.
          ZenCricketData is still in private beta — public access opens
          shortly. We've saved your account; you'll get an email the
          moment we're ready for you.
        </p>

        <p className="text-text-secondary text-sm mb-8">
          Questions in the meantime? Write to{" "}
          <a
            href="mailto:a.manivannan@sportingzenminds.com"
            className="text-button-primary hover:underline"
          >
            a.manivannan@sportingzenminds.com
          </a>
          .
        </p>

        <button
          type="button"
          onClick={handleSignOut}
          className="text-sm text-text-secondary hover:text-text-primary underline underline-offset-2"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
